import React from 'react'
import { Chip, CircularProgress } from '@mui/material'
import { STATUS_META } from '../constants'

/** Colour-coded status chip (BRD §7.3); PROCESSING carries a spinner. */
export default function StatusChip({ status, size = 'small' }) {
  const meta = STATUS_META[status] || { label: status, color: 'default' }
  return (
    <Chip
      size={size}
      label={meta.label}
      color={meta.color === 'default' ? undefined : meta.color}
      variant={meta.color === 'default' ? 'outlined' : 'filled'}
      icon={meta.spinner ? <CircularProgress size={12} color="inherit" /> : undefined}
    />
  )
}
